<template>
  <div>
    <app-header />
    <main>
      <hero-section />
      <about-section />
      <services-section />
      <why-us-section />
      <contact-section />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import HeroSection from '@/components/LandingPage/HeroSection.vue';
import AboutSection from '@/components/LandingPage/AboutSection.vue';
import ServicesSection from '@/components/LandingPage/ServicesSection.vue';
import WhyUsSection from '@/components/LandingPage/WhyUsSection.vue';
import ContactSection from '@/components/LandingPage/ContactSection.vue';

export default {
  name: 'LandingPage',
  components: {
    AppHeader,
    AppFooter,
    HeroSection,
    AboutSection,
    ServicesSection,
    WhyUsSection,
    ContactSection
  }
};
</script>
